import { EnvironmentId } from '@/react/portainer/environments/types';

export const queryKeys = {
  base: (environmentId: EnvironmentId) => [
    'environments',
    environmentId,
    'trivy',
  ],
  vulnerabilityReportTable: (environmentId: EnvironmentId) =>
    [
      ...queryKeys.base(environmentId),
      'vulnerabilityreports',
      'table',
    ] as const,
  vulnerabilityReports: (
    environmentId: EnvironmentId,
    namespace?: string,
    resourceName?: string
  ) =>
    [
      ...queryKeys.base(environmentId),
      'vulnerabilityreports',
      namespace ?? 'all-namespaces',
      resourceName ?? 'all-workloads',
    ] as const,
};
